module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Frying-pan-b902f6160ea48ae081242e306792acb0.svg";